import styled, { css } from 'styled-components'

export const Container = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.xSmall};
        width: 100%;
        box-sizing: border-box;
        padding: ${theme.spacing.xSmall} 0 ${theme.spacing.medium};
        border-bottom: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwDefaultInputBorder};
    `,
)

export const Header = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xSmall};
        padding-bottom: 0.5rem;
    `,
)

export const Title = styled.h3(
    ({ theme }) => css`
        margin: 0;
        color: ${theme.colors.tfwViolet};
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.medium};
        font-weight: ${theme.typography.font.lato.weight.semiBold};
        line-height: ${theme.typography.font.size.xLarge};
    `,
)

export const SubmitButton = styled.button(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing.xSmall};
        width: 100%;
        padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlack87};
        border-radius: ${theme.typography.border.radius.medium};
        background-color: ${theme.colors.white};
        color: ${theme.colors.tfwBlack87};
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        font-weight: ${theme.typography.font.lato.weight.semiBold};
        cursor: pointer;

        /* Inset rather than a thicker border, which would shift the layout by a pixel on hover. */
        &:hover:not(:disabled) {
            box-shadow: inset 0 0 0 ${theme.typography.border.width.xxxThin} ${theme.colors.tfwBlack87};
        }

        &:disabled {
            border-color: ${theme.colors.tfwBlack12};
            color: ${theme.colors.tfwBlack38};
            cursor: not-allowed;
        }
    `,
)
